"use strict";
export const isPrimitive = (val) => {
  const type = typeof val;
  if (type === "object") {
    return val === null;
  }
  return type !== "function";
};
export const isObject = (val) => val !== null && typeof val === "object";
//# sourceMappingURL=primitive.js.map
